import React from 'react';
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faStarHalf } from '@fortawesome/pro-solid-svg-icons/faStarHalf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import getStarCounts from '../utils/rating';
import { onEnterAction } from '../utils/a11y';

const STAR_COLOR_ACTIVE = 'text-honey';
const STAR_COLOR_INACTIVE = 'text-gray-200';

interface Props {
  rating: number;
  reviewCount: number;
  size?: string;
  onClick?: () => void;
  className?: string;
  ariaLabel?: string;
}

export const StarRating = ({
  rating,
  reviewCount,
  size = 'base',
  onClick,
  className = '',
  ariaLabel,
}: Props): JSX.Element => {
  const stars = getStarCounts(rating);
  const isInteractive = !!onClick;

  const interactiveProps = isInteractive ? {
    onClick: (e: React.MouseEvent): void => { e.stopPropagation(); onClick(); },
    onKeyDown: (e: React.KeyboardEvent<HTMLElement>): void => { e.stopPropagation(); onEnterAction(e, onClick); },
    role: 'button' as const,
    tabIndex: 0 as const,
    'aria-label': ariaLabel,
  } : {};

  return (
    <div
      className={`flex items-center${isInteractive ? ' cursor-pointer' : ''}${className ? ` ${className}` : ''}`}
      {...interactiveProps}
    >
      {stars.whole.map(i =>
        <FontAwesomeIcon key={`whole-${i}`} icon={faStar} className={`mr-1 text-${size} self-center ${STAR_COLOR_ACTIVE}`} />)}
      {stars.half &&
        <>
          <FontAwesomeIcon icon={faStarHalf} className={`-mr-1 text-${size} self-center ${STAR_COLOR_ACTIVE}`} />
          <FontAwesomeIcon icon={faStarHalf} className={`-ml-3.5 mr-1 text-${size} self-center fa-flip-horizontal ${STAR_COLOR_INACTIVE}`} />
        </>}
      {stars.empty.map(i =>
        <FontAwesomeIcon key={`empty-${i}`} icon={faStar} className={`mr-1 text-${size} self-center ${STAR_COLOR_INACTIVE}`} />)}
      <span className={`font-semibold text-${size} ml-2 mt-[2px]`}>{reviewCount}</span>
    </div>
  );
};
